import { setBlockTracking as _setBlockTracking, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl" }
const _hoisted_2 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_section_story_available_languages = _resolveComponent("project-section-story-available-languages")
  const _component_project_section_story_properties = _resolveComponent("project-section-story-properties")
  const _component_project_section_backing_information = _resolveComponent("project-section-backing-information")
  const _component_richtext_article = _resolveComponent("richtext-article")

  return _cache[0] || (
    _setBlockTracking(-1, true),
    (_cache[0] = _createElementVNode("main", {
      class: "gfu-project-description-section gfu-project-description-section--emphasized js-main-content",
      "data-qa": `project-description-section:${$props.projectDescriptionSectionId}`
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", {
          ref: "header",
          class: "gfu-hd gfu-hd--h2 gfu-heading--top-divider _mb-2",
          "data-qa": `project-description-section-title:${$props.header}`
        }, _toDisplayString($props.header), 9 /* TEXT, PROPS */, _hoisted_2),
        ($options.isLanguageSelectorVisible)
          ? (_openBlock(), _createBlock(_component_project_section_story_available_languages, {
              key: 0,
              "available-languages": $props.availableLanguages
            }, null, 8 /* PROPS */, ["available-languages"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_project_section_story_properties, {
          "project-tags": $props.projectTags,
          "project-category": $props.projectCategory,
          "project-properties": $props.projectProperties
        }, null, 8 /* PROPS */, ["project-tags", "project-category", "project-properties"]),
        ($options.isBackingInformationSectionVisible)
          ? (_openBlock(), _createBlock(_component_project_section_backing_information, {
              key: 1,
              "is-stretch-pay-enabled": $options.isStretchPaySectionVisible,
              "is-stable-pledge-enabled": $options.isStablePledgeSectionVisible,
              "is-crowdfunding-risks-enabled": $options.isCrowdfundingRisksSectionVisible,
              "project-original-type": $options.projectOriginalType
            }, null, 8 /* PROPS */, ["is-stretch-pay-enabled", "is-stable-pledge-enabled", "is-crowdfunding-risks-enabled", "project-original-type"]))
          : _createCommentVNode("v-if", true),
        ($props.content)
          ? (_openBlock(), _createBlock(_component_richtext_article, {
              key: 2,
              ref: "content",
              content: $props.content,
              class: "_mt-2"
            }, null, 8 /* PROPS */, ["content"]))
          : _createCommentVNode("v-if", true)
      ])
    ], 8 /* PROPS */, ["data-qa"])).cacheIndex = 0,
    _setBlockTracking(1),
    _cache[0]
  )
}